module.exports = __webpack_public_path__ + "static/media/pin.b63d66c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalRule/pin.svg
// module id = 316
// module chunks = 0